import { Provider } from '@angular/core';
import { PriceApiService, providePriceApiOrigin } from '@isaia/price';
import { PriceService } from './price.service';
import { PriceRepository } from './price.repository';

export function providePrice(options: { origin: string }): Provider {
  return [providePriceApiOrigin(options.origin), PriceApiService, PriceService, PriceRepository];
}
